"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setDictateState;
exports.SET_DICTATE_STATE = void 0;
var SET_DICTATE_STATE = 'WEB_CHAT/SET_DICTATE_STATE';
exports.SET_DICTATE_STATE = SET_DICTATE_STATE;

function setDictateState(dictateState) {
  return {
    type: SET_DICTATE_STATE,
    payload: {
      dictateState: dictateState
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldERpY3RhdGVTdGF0ZS5qcyJdLCJuYW1lcyI6WyJTRVRfRElDVEFURV9TVEFURSIsInNldERpY3RhdGVTdGF0ZSIsImRpY3RhdGVTdGF0ZSIsInR5cGUiLCJwYXlsb2FkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsaUJBQWlCLEdBQUcsNEJBQTFCOzs7QUFFZSxTQUFTQyxlQUFULENBQXlCQyxZQUF6QixFQUF1QztBQUNwRCxTQUFPO0FBQ0xDLElBQUFBLElBQUksRUFBRUgsaUJBREQ7QUFFTEksSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLFlBQVksRUFBWkE7QUFBRjtBQUZKLEdBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFVF9ESUNUQVRFX1NUQVRFID0gJ1dFQl9DSEFUL1NFVF9ESUNUQVRFX1NUQVRFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0RGljdGF0ZVN0YXRlKGRpY3RhdGVTdGF0ZSkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFVF9ESUNUQVRFX1NUQVRFLFxuICAgIHBheWxvYWQ6IHsgZGljdGF0ZVN0YXRlIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VUX0RJQ1RBVEVfU1RBVEUgfTtcbiJdfQ==